import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  RESET_PASSWORD_SUCCESS
} from "constants/ActionTypes";
import * as Constants from "../common/Constants"

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  initURL: "",
  authUser: localStorage.getItem("user_token"),
  status: "",
  authLoader: true,
  isAuthorized: false,
  authApiResponse: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      };
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      };
    }
    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        loader: false,
        status: action.payload
      };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: "/app/home",
        loader: false
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false
      };
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      };
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      };
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      };
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      };
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      };
    }
    case Constants.REQUEST_CHECK_AUTHORIZATION: {
      return {
        ...state,
        authLoader: true,
        isAuthorized: false
      }
    }
    case Constants.SUCCESS_CHECK_AUTHORIZATION: {
      return {
        ...state,
        authLoader: false,
        isAuthorized: true
      }
    }
    case Constants.FAILED_CHECK_AUTHORIZATION: {
      return {
        ...state,
        authLoader: false,
        isAuthorized: false
      }
    }
    case Constants.REQUEST_SIGN_IN: {
      return {
        ...state,
        loader: true,
        authApiResponse: null
      }
    }
    case Constants.SUCCESS_SIGN_IN: {
      return {
        ...state,
        loader: false,
        authUser: action.token,
        authApiResponse: null
      }
    }
    case Constants.FAILED_SIGN_IN: {
      return {
        ...state,
        loader: false,
        authApiResponse: action.apiResponse
      }
    }
    case Constants.RESET_AUTH_API_RESPONSE: {
      return {
        ...state,
        authApiResponse: null
      }
    }
    default:
      return state;
  }
};
